import { defineStore } from 'pinia'
import { site } from '@/libs/api'
import orderBy from 'lodash.orderby'

export const useCountries = defineStore('countries', {
  state: () => ({
    items: [],
  }),
  actions: {
    init() {
      return site.getCountryList().then(({ data }) => {
        this.items = orderBy(
          data.map((item) => ({
            id: item.id,
            label: item.label,
            iso2: item.id,
            iso3: item.iso3,
          })),
          'label',
        )
      })
    },
    getCountryById(id) {
      return this.items.find((i) => i.id === id)
    },
  },
})
